import { PageShell } from '../components';
import { PageBody, PageHero, Section, FeatureRows, Prose, SmartLink } from '../components/page';

const LINKS = [
  {
    title: 'About the founder',
    body: 'Who builds Statio, on romans.dev.',
    href: 'https://romans.dev/about',
    linkLabel: 'romans.dev/about',
  },
  {
    title: 'Product portfolio',
    body: 'The other products SID Technologies builds.',
    href: 'https://romans.dev',
    linkLabel: 'romans.dev',
  },
];

export default function AboutPage() {
  return (
    <PageShell>
      <PageBody>
        <PageHero
          title="About Statio"
          lede={
            <>
              Statio is built by <SmartLink href="https://romans.dev/about">SID Technologies</SmartLink>, a company
              building infrastructure and applications for modern financial and AI-native workflows.
            </>
          }
          art="aqueduct"
        />
        <Section id="name" title="The name" split>
          <Prose>
            <p>
              Named after the Roman military guard station, Statio is the fortified checkpoint between your AI agents
              and the APIs they call. Encrypted credential storage, per-tool access, audit trails: the part MCP leaves
              to you.
            </p>
          </Prose>
        </Section>
        <Section id="links" title="Links" split>
          <FeatureRows items={LINKS} columns={1} />
        </Section>
        <Section id="contact" title="Contact" split>
          <Prose>
            <p>
              Email <a href="mailto:dans@romans.dev">dans@romans.dev</a>.
            </p>
          </Prose>
        </Section>
      </PageBody>
    </PageShell>
  );
}
